<template>
    <el-dialog modal-append-to-body append-to-body :visible="detail!=null" title="查看详情" width="1500px"
               @close="closeDialog">
        <el-form :model="info" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="描述：" prop="description">
                {{info.description}}
            </el-form-item>
            <el-form-item v-if="info.taskStatus === 0" label="导入数据：" prop="incubatorAirDrops">
                <import-airdrop v-model="incubatorAirDrops" @change="handleImport"/>
            </el-form-item>

            <div style="margin-top: 20px;margin-bottom: 10px">
                <el-input v-model="queryParams.userId" placeholder="用户ID" style="width: 300px"></el-input>
                <el-select v-model="queryParams.airDeopStatusArr" filterable multiple placeholder="请选择状态"
                           style="width: 50%">
                    <el-option label="未转账" :value="0"></el-option>
                    <el-option label="转账中" :value="1"></el-option>
                    <el-option label="已经转账" :value="2"></el-option>
                    <el-option label="转账失败" :value="3"></el-option>
                </el-select>
                <el-button type="primary" @click="searchData">搜 索</el-button>
            </div>
            <el-table v-loading="loading" :data="airdrops" border style="width: 100%">
                <el-table-column prop="userId" label="用户ID"/>
                <el-table-column prop="coinType" label="空投币种"/>
                <el-table-column prop="coinAmount" label="空投数量"/>
                <el-table-column prop="payCoinType" label="支付币种"/>
                <el-table-column prop="payCoinAmount" label="支付数量"/>
                <el-table-column prop="dropStatus" label="状态">
                    <template slot-scope="scope">{{parseStatusTran(scope.row.dropStatus)}}</template>
                </el-table-column>
                <el-table-column prop="errorMsg" label="转账失败信息"/>
            </el-table>
            <pagination :size="airdropPagination.size" :page="airdropPagination.page" :total="airdropTotalCount"
                        @pageChanged="handleCurrentChange">
            </pagination>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import {mapActions, mapState, mapMutations} from 'vuex';
    import Pagination from 'components/pagination';
    import api from '../../api';
    import importAirdrop from '../import';

    export default {
        name: 'airdropDetail',
        data() {
            return {
                info: {},
                incubatorAirDrops: [],
                loading: false,
                rules: {
                    importAirDrop: {
                        type: 'array',
                        required: true,
                        message: '请填写',
                        trigger: 'change'
                    }
                },
                queryParams: {
                    airDeopStatusArr: [],
                    airDeopStatus: "",
                    userId: ""
                }
            };
        },
        computed: {
            ...mapState('incubatorAirDrop', [
                'detail',
                'airdropPagination',
                'airdropTotalCount',
                'airdrops'
            ])
        },
        components: {
            importAirdrop,
            Pagination
        },
        watch: {
            detail(val) {
                if (val) {
                    this.info = (val && Object.assign({}, val)) || {};
                    this.getAirDropList({
                        taskId: val.id,
                        page: 1
                    });
                } else {
                    this.info = {};
                }
            }
        },
        methods: {
            ...mapMutations('incubatorAirDrop', ['setDetail']),
            ...mapActions('incubatorAirDrop', ['importAirDrop', 'reqAirDrops']),
            closeDialog() {
                this.setDetail(null);
                this.$refs['form'].resetFields();
            },
            handleCurrentChange(pagination) {
                this.getAirDropList(pagination);
            },
            searchData() {
                this.queryParams.airDeopStatus = this.queryParams.airDeopStatusArr.join(",");
                this.getAirDropList(this.queryParams);
            },
            getAirDropList(data = {}) {
                this.loading = true;
                this.reqAirDrops({
                    taskId: this.info.id,
                    ...this.airdropPagination,
                    ...data
                }).then(() => {
                    this.loading = false;
                });
            },
            handleImport() {
                const that = this;
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        this.importAirDrop({
                            taskId: this.info.id,
                            incubatorAirDrops: JSON.stringify(this.incubatorAirDrops)
                        }).then(() => {
                            this.$message({
                                message: '修改成功！',
                                type: 'success'
                            });
                            this.getAirDropList({
                                page: 1
                            });
                        });
                    }
                });
            },
            parseStatusTran(status) {
                if (status === 0) {
                    return '未转账';
                }
                if (status === 1) {
                    return '转账中';
                }
                if (status === 2) {
                    return '已经转账';
                }
                if (status === 3) {
                    return '转账失败';
                }
            }
        },
        mounted() {
            if (this.info && this.info.id) {
                getAirDropList({
                    page: 1
                });
            }
        }
    };
</script>
